import { createContext } from "react";
import {
  PublicUserOrganization,
  OrganizationProjectsQuery,
} from "../../__generated__/graphql";

type Project = OrganizationProjectsQuery["projects"][number];

interface DashboardContextType {
  selectedUsers: PublicUserOrganization[];
  setSelectedUsers: (users: PublicUserOrganization[]) => void;
  selectedProjects: Project[];
  setSelectedProjects: (projects: Project[]) => void;
}

export const DashboardContext = createContext<DashboardContextType>({
  selectedUsers: [],
  setSelectedUsers: () => {},
  selectedProjects: [],
  setSelectedProjects: () => {},
});
